import type { User } from 'src/types/user';

export const users: User[] = [
  {
    id: '5e86809283e28b96d2d38537',
    avatar: '/assets/avatars/avatar-anika-visser.png',
    email: 'demo@devias.ios',
    name: 'Anika Visser',
    password: 'Password123!',
    plan: 'Premium',
  },
];
